@let label = labelSg();
@let typedValue = typedValueSg();

@if (readonlySg()) {
  <atn-readonly-value
    [label]="label"
    [type]="typedValue.type"
    [value]="typedValue.value"
  />
} @else {
  <atn-input-value
    [label]="label"
    [typedValue]="typedValue"
    (typedValueChange)="typedValueChangeHandler($event)"
    [required]="requiredSg()"
    [documentKey]="documentKeySg()"
    [recordTarget]="recordTargetSg()"
  />
}
